import { attrConfig as valConfig } from './w-val.js';

/** @type {import('@translator').AttrConfig[]} */
export default [valConfig];
